module.exports = __webpack_public_path__ + "static/img/zhongzhongka10.b03e948.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka10.png
// module id = DOkS
// module chunks = 16